module.exports = __webpack_public_path__ + "06252137649aacdbd08eb42bc7d095b8.png";